type DebugValue = "set-true" | "set-false" | "unset";

export default class DebugUtil {
    /**
     * Checks if either the debug value is true or the host is local/dev and debug is no false
     */
    public static isDebugEnabled(): boolean {
        let debugValue = this.DebugValueSet();
        let isDevHost = this.isDevHost();

        return debugValue === "set-true" || (debugValue !== "set-false" && isDevHost);
    }

    public static DebugValueSet(): DebugValue {
        let item = localStorage.getItem("debug");
        if (item == null) {
            return "unset";
        } else if (item.toLowerCase() === "true") {
            return "set-true";
        } else {
            return "set-false";
        }
    }

    public static isDevHost(): boolean {
        let currentShortUrl: string = (window.location.hostname || "").toLowerCase();
        let allowedUrls: string[] = ["localhost", "kudergalaxy-web-dev.azurewebsites.net"];
        return allowedUrls.some(x => x.toLowerCase() === currentShortUrl);
    }
}



// WEBPACK FOOTER //
// ./src/utils/DebugUtil.ts